import React, { useState } from "react";
import "./Donate.css";

const API = "https://backend-ourcountryourpeople-4.onrender.com";

export default function Donate() {
  const [formData, setFormData] = useState({
    donationTowards: "",
    schemeName: "",
    amount: "",
    name: "",
    mobile: "",
    email: "",
    pan: "",
    receiptName: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const loadRazorpay = () =>
    new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const loaded = await loadRazorpay();
    if (!loaded) return alert("Razorpay SDK load failed");

    try {
      /* ✅ CREATE ORDER (send ONLY rupees) */
      const orderRes = await fetch(`${API}/razorpay/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: Number(formData.amount),
        }),
      });

      const orderData = await orderRes.json();
      if (!orderData.success) return alert("Order creation failed");

      const order = orderData.order;

      const options = {
        key: "rzp_live_RtTtsd43ueuekb",
        amount: order.amount,
        currency: "INR",
        order_id: order.id,
        name: "Our Country Our People Foundation",
        description: "Donation",

        handler: async function (response) {
          const verifyRes = await fetch(`${API}/razorpay/verify-payment`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,

              name: formData.name,
              email: formData.email,
              amount: formData.amount,
            }),
          });

          const data = await verifyRes.json();

          if (data.success) {
            window.open(`${API}${data.receiptUrl}`, "_blank");
            alert("Payment successful");
          } else {
            alert("Payment verification failed");
          }
        },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <select name="donationTowards" onChange={handleChange} required>
        <option value="">----- Select an Option -----</option>
        <option value="old_age_home">Old Age Home</option>
      </select>

      <select name="schemeName" onChange={handleChange} required>
        <option value="">----- Select an Option -----</option>
        <option value="amma_unavagam">For food</option>
        <option value="vidhya_dhan">Health care</option>
      </select>

      <input name="amount" type="number" onChange={handleChange} placeholder="Amount" required />
      <input name="name" onChange={handleChange} placeholder="Name" required />
      <input name="mobile" onChange={handleChange} placeholder="Mobile" required />
      <input name="email" type="email" onChange={handleChange} placeholder="Email" />

      <button type="submit">Donate</button>
    </form>
  );
}
